import React from 'react';
import PropTypes from 'prop-types';

export default class CardBody extends React.Component {

    render() {
        const { className, styles } = this.props;

        return (
            <div className={`body ${className}`} style={styles}>
                {this.props.children}
            </div>
        );
    }

}

CardBody.propTypes = {
    className: PropTypes.string,
    styles: PropTypes.object,
};

CardBody.defaultProps = {
    className: '',
};



// WEBPACK FOOTER //
// ./src/app/shared/components/CardBody.jsx